import React from 'react'
import { Link } from 'react-router-dom'

function RealEstateGuide() {
  return (
    <section class="lifestyle-explore-main container mt-5 mb-5">
    <div class="guide-text mb-4  ">
      <h5 class="fw-bold">Your Real Estate Guide</h5>
    </div>

    <div class="lifestyle-content row row-cols-1 row-cols-sm-2 row-cols-lg-4 row-cols-md-3 justify-content-between pb-4 mt-4 gy-4">
     <Link to="/home/homebuying-guidance">  
      <div class="card lifestyle-crd col">
        <div class="card-body lifestyle-crd-bd ">
          <div className="guide-img">
            <img
              class="h-100 w-100"
              src="./images/illustration/construction.png "
              alt=""
            />
          </div>
          <h6 class="card-title lifestyle-crd-heading">
            Home Buying Guide
          </h6>
          <p class="card-subtitle lifestyle-para mb-2 text-body-secondary">
          Your Step-by-Step Guide to Smart Home Buying
          </p>

          {/* <!-- <a href="#" class="card-link btn exp-all">Explore all <i class="bi bi-caret-right-fill"></i></a> --> */}
        </div>
      </div>
      </Link>  
      <Link to="/home/homedesign-guidance">
      <div class="card lifestyle-crd col">
        <div class="card-body lifestyle-crd-bd ">
          <div className="guide-img">
            <img
              class="h-100 w-100"
              src="./images/illustration/interior-design.png "
              alt=""
            />
          </div>

          <h6 class="card-title lifestyle-crd-heading">Home Design</h6>
          <p class="card-subtitle lifestyle-para mb-2 text-body-secondary">
          Inspiration & Tips for Your Dream Home Design
          </p>

          {/* <!-- <a href="#" class="card-link btn exp-all">Explore all <i class="bi bi-caret-right-fill"></i></a> --> */}
        </div>
      </div>
      </Link>
      <Link to="/home/homeloan-guidance">
      <div class="card lifestyle-crd col">
        <div class="card-body lifestyle-crd-bd ">
          <div className="guide-img">
            <img
              class="h-100 w-100"
              src="./images/illustration/signing.png"
              alt=""
            />
          </div>
          <h6 class="card-title lifestyle-crd-heading"> Loan/Documents</h6>
          <p class="card-subtitle lifestyle-para mb-2 text-body-secondary">
            Everything You Need to Know About Loans & Documents
          </p>

          {/* <!-- <a href="#" class="card-link btn exp-all">Explore all <i class="bi bi-caret-right-fill"></i></a> --> */}
        </div>
      </div>
      </Link>
      <Link to="/home/propertyevaluation-guidance">
      <div class="card lifestyle-crd col">
        <div class="card-body lifestyle-crd-bd ">
          <div className="guide-img">
            <img
              class="h-100 w-100"
              src="./images/illustration/analysis.png "
              alt=""
            />
          </div>
          <h6 class="card-title lifestyle-crd-heading">
            Property Valuation
          </h6>
          <p class="card-subtitle lifestyle-para mb-2 text-body-secondary">
          Understand Your Property's True Worth
          </p>

          {/* <!-- <a href="#" class="card-link btn exp-all">Explore all <i class="bi bi-caret-right-fill"></i></a> --> */}
        </div>
      </div>
      </Link>
    </div>
  </section>
  )
}

export default RealEstateGuide